import React from "react";
import { gerarLinkWhatsApp } from "../../utils/WhatsappLink";
import { Divider } from "@mui/material";
import Seo from "../../components/Seo";

const featuredPost = {
    title: "Nunca declarei imposto de renda como autônomo. O que acontece agora?",
    excerpt: "Respira. Você não é o único. Mas também não é hora de continuar ignorando. A boa notícia: dá para resolver, e o caminho mais barato sempre é agir antes de ser chamado.",
    image: "assets/nunca declarei.jpg",
};

const posts = [
    {
        id: 1,
        title: "Freelancer PJ: guia completo de obrigações fiscais para quem presta serviço para empresas",
        excerpt: "Você fechou o contrato, entregou o projeto, recebeu o pagamento, mas e a parte fiscal?",
        image: "assets/freelancer.jpg",
        path: "/Blog/freelancer-pj",
    },
    {
        id: 2,
        title: "Nunca declarei imposto de renda como autônomo. O que acontece agora?",
        excerpt: "Respira. Você não é o único. Mas também não é hora de continuar ignorando. A boa notícia: dá para resolver",
        image: "assets/nunca declarei.jpg",
        path: "/Blog/nunca-declarei-imposto",
    },
    {
        id: 3,
        title: "Benefícios de Declarar Corretamente os Impostos",
        excerpt: "Declarar corretamente os impostos não é apenas uma obrigação, é uma das melhores decisões financeiras que você pode tomar.",
        image: "assets/beneficios.jpg",
        path: "/Blog/beneficios-de-declarar-corretamente-os-impostos",
    },
    {
        id: 4,
        title: "Riscos de Não Declarar os Impostos Devidos: O Que Pode Acontecer Com Você",
        excerpt: "A Receita Federal não esquece. E quanto mais tempo você espera, mais caro fica",
        image: "assets/quais são os riscos.jpg",
        path: "/Blog/riscos-de-nao-declarar-os-impostos-devidos-o-que-pode-acontecer-com-voce",
    },
    // {
    //     id: 5,
    //     title: "Quanto o criador de conteúdo realmente paga de imposto, e como pagar menos de forma legal",
    //     excerpt: "YouTuber, influenciador, streamer. Não importa o canal, se você está monetizando, o Leão já tem os olhos em você.",
    //     image: "assets/quanto-o-criador-de-conteudo.jpg",
    //     path: "/Blog/quanto-o-criador-de-conteudo-realmente-paga-de-imposto-e-como-pagar-menos-de-forma-legal",
    // },
    // {
    //     id: 6,
    //     title: "MEI ou Microempresa",
    //     excerpt: "Você foi crescendo, os clientes foram chegando, e agora bateu aquela dúvida que ninguém te preparou para ter. Aqui você vai entender quando é hora de dar o próximo passo.",
    //     image: "assets/mei-ou-microempresa.jpg",
    //     path: "/Blog/mei-ou-microempresa",
    // },
];

export default function Blog() {
    return (
        <>
            <Seo
                title="Blog Contblack | Impostos, CNPJ e Contabilidade"
                description="Artigos sobre impostos, abertura de empresa e planejamento tributário."
            />
            <div
                style={{
                    minHeight: "100vh",
                    backgroundColor: "#f3f4f6",
                    fontFamily: "Arial, sans-serif",
                }}
            >
                {/* HEADER */}
                <header
                    style={{
                        position: "relative",
                        zIndex: 2,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "30px 40px",
                        flexWrap: "wrap",
                        gap: "20px",
                    }}
                >
                    <h1
                        style={{
                            fontSize: "clamp(1.5rem, 4vw, 2rem)",
                            fontWeight: "800",
                            margin: 0,
                            lineHeight: 1.1,
                        }}
                    >
                        <span style={{ color: "black" }}>Contblack</span>
                        <span style={{ color: "#1EFF86" }}> blog</span>
                    </h1>

                    <nav
                        style={{
                            display: "flex",
                            gap: "24px",
                            alignItems: "center",
                            flexWrap: "wrap",
                            justifyContent: "center",
                        }}
                    >
                        <a
                            href="/"
                            style={{
                                color: "black",
                                textDecoration: "none",
                                fontSize: "15px",
                                fontWeight: 500,
                                transition: "0.3s",
                                whiteSpace: "nowrap",
                            }}
                        >
                            Site
                        </a>

                        <a
                            href={gerarLinkWhatsApp("Olá, vim pelo blog e gostaria de atendimento.")}
                            style={{
                                color: "black",
                                textDecoration: "none",
                                fontSize: "15px",
                                fontWeight: 500,
                                transition: "0.3s",
                                whiteSpace: "nowrap",
                            }}
                        >
                            Falar com especialista
                        </a>
                    </nav>
                </header>
                <Divider style={{ margin: "0 40px", borderColor: "#e5e7eb" }} />

                <main
                    style={{
                        maxWidth: "1200px",
                        margin: "0 auto",
                        padding: "40px 20px",
                    }}
                >
                    {/* ARTIGO EM DESTAQUE */}
                    <section style={{ marginBottom: "60px" }}>
                        <h2
                            style={{
                                fontSize: "28px",
                                marginBottom: "24px",
                                color: "#111827",
                            }}
                        >
                            Artigo em destaque
                        </h2>

                        <div
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                                backgroundColor: "#fff",
                                borderRadius: "20px",
                                overflow: "hidden",
                                boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                            }}
                        >
                            <img
                                src={featuredPost.image}
                                alt={featuredPost.title}
                                style={{
                                    width: "100%",
                                    maxWidth: "600px",
                                    objectFit: "cover",
                                }}
                            />

                            <div
                                style={{
                                    flex: 1,
                                    padding: "40px",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                }}
                            >
                                <span
                                    style={{
                                        color: "#D43C2E",
                                        fontWeight: "bold",
                                        marginBottom: "12px",
                                        textTransform: "uppercase",
                                    }}
                                >
                                    CONTBLACK
                                </span>

                                <h3
                                    style={{
                                        fontSize: "35px",
                                        marginBottom: "20px",
                                        color: "#111827",
                                    }}
                                >
                                    {featuredPost.title}
                                </h3>

                                <p
                                    style={{
                                        fontSize: "18px",
                                        color: "#4b5563",
                                        marginBottom: "30px",
                                        lineHeight: "1.6",
                                    }}
                                >
                                    {featuredPost.excerpt}
                                </p>

                                <button
                                    style={{
                                        width: "fit-content",
                                        backgroundColor: "#111827",
                                        color: "#fff",
                                        border: "none",
                                        padding: "14px 24px",
                                        borderRadius: "10px",
                                        cursor: "pointer",
                                        fontSize: "16px",
                                    }}
                                    onClick={() => window.location.href = "/Blog/nunca-declarei-imposto"}
                                >
                                    Ler artigo
                                </button>
                            </div>
                        </div>
                    </section>

                    {/* LISTA DE POSTS */}
                    <section>
                        <h2
                            style={{
                                fontSize: "28px",
                                marginBottom: "24px",
                                color: "#111827",
                            }}
                        >
                            Últimos artigos
                        </h2>

                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                                gap: "24px",
                            }}
                        >
                            {posts.map((post) => (
                                <div
                                    key={post.id}
                                    style={{
                                        backgroundColor: "#fff",
                                        borderRadius: "18px",
                                        overflow: "hidden",
                                        boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
                                        transition: "0.3s",
                                    }}
                                >
                                    <img
                                        src={post.image}
                                        alt={post.title}
                                        style={{
                                            width: "100%",
                                            height: "180px",
                                            objectFit: "cover",
                                        }}
                                    />

                                    <div style={{ padding: "20px" }}>
                                        <h3
                                            style={{
                                                fontSize: "20px",
                                                color: "#111827",
                                                marginBottom: "12px",
                                            }}
                                        >
                                            {post.title}
                                        </h3>

                                        <p
                                            style={{
                                                fontSize: "15px",
                                                color: "#6b7280",
                                                lineHeight: "1.5",
                                                marginBottom: "20px",
                                            }}
                                        >
                                            {post.excerpt}
                                        </p>

                                        <button
                                            style={{
                                                backgroundColor: "transparent",
                                                border: "none",
                                                color: "#2563eb",
                                                cursor: "pointer",
                                                fontWeight: "bold",
                                                padding: 0,
                                            }}
                                            onClick={() => window.location.href = post.path}
                                        >
                                            Ler mais →
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>
                </main>
            </div>
        </>
    );
}